export default "__VITE_ASSET__$Lt69gbS__"